export const SPLIT_SEPARATORS = [',', ', ', ';', ' '];
